<template>
    <div>
        <WaitingPrice
            :entity-type="BUSINESS_TYPE.PHARMACY"
        >
        </WaitingPrice>
    </div>
</template>

<script>
    import WaitingPrice from '@/components/waiting-price/WaitingPrice';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityWaitingPrice',

        components: {
            WaitingPrice
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
